import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
    AddConnection: "ADD_CONNECTION",
    RemoveConnections: "REMOVE_CONNECTION",
};

const initialConfirmModalState = {
    hubs: []
};

export const reducer = (state = initialConfirmModalState, action) => {

    switch (action.type) {
        case actionTypes.AddConnection: {
            return {
                hubs: [...state.hubs, action.hub]
            };
        }

        case actionTypes.RemoveConnections: {
            return {
                hubs: []
            };
        }

        default:
            return state;
    }
};

export const actions = {
    addConnectionHub: (hub) => ({ type: actionTypes.AddConnection, hub: hub }),
    removeConnectionHub: () => ({ type: actionTypes.RemoveConnections }),
};
